import { useState, useEffect } from 'react'
import { Grid } from '@material-ui/core'
import Modal from 'shared/components/Modal'
import { MdAccessTime } from 'react-icons/md'
import { colors } from 'shared/styles/colors'
import { ELockOCMessageTypes } from '../../utils/ELockOCMessage'
import { ContainerIcon, Message, StyleButton, StyledCheck } from './styles'

const MESSAGE_SEND_SMS =
  'Fique tranquilo. Te avisaremos assim que essa solicitação de viagem for atualizada.'
const MESSAGE_DONT_SEND_SMS =
  'Essa viagem está <b>aguardando aprovação</b> do time de operações.'

type TProps = {
  openModal?: boolean
  setAlertType?: (arg0: ELockOCMessageTypes) => void
  smsConfig: boolean
}

const ModalWaitForNotification: React.FC<TProps> = ({
  openModal,
  setAlertType,
  smsConfig,
}) => {
  const [message, setMessage] = useState('')

  useEffect(() => {
    if (smsConfig) {
      setMessage(MESSAGE_SEND_SMS)
    } else {
      setMessage(MESSAGE_DONT_SEND_SMS)
    }
  }, [smsConfig])

  return (
    <>
      <Modal
        openModal={openModal}
        size={'small'}
        showCloseButton={true}
        onCloseModal={() => setAlertType(ELockOCMessageTypes.NENHUM)}
      >
        <Grid
          md={12}
          container
          spacing={2}
          justify="space-between"
          alignItems="center"
          style={{ textAlign: 'center', height: '100%' }}
        >
          <Grid container alignItems="center" justify="center" spacing={4}>
            <Grid item>
              <ContainerIcon>
                {smsConfig ? (
                  <StyledCheck width={90} color={colors.blue} />
                ) : (
                  <MdAccessTime size={90} color={colors.blue} />
                )}
              </ContainerIcon>
            </Grid>
          </Grid>

          <Grid container item>
            <Message
              dangerouslySetInnerHTML={{
                __html: `${message}`,
              }}
            />
          </Grid>

          <Grid container alignItems="center" justify="center" item>
            <StyleButton
              color={colors.green}
              onClick={() => {
                setAlertType(ELockOCMessageTypes.NENHUM)
              }}
            >
              Concluir
            </StyleButton>
          </Grid>
        </Grid>
      </Modal>
    </>
  )
}

export default ModalWaitForNotification
